import './styles/App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, AuthContext } from "./context/AuthContext";
import { ImportProvider } from "./context/ImportContext";
import ImportBanner from "./components/ImportBanner";
import PrivateRoute from "./components/PrivateRoute";
import React, { useContext } from 'react';
import Home from './pages/Home';
import OutfitsToday from './pages/OutfitsToday';
import AddClothing from './pages/AddClothing';
import Dressing from './pages/Dressing';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import Settings from './pages/Settings';
import Suggestions from './pages/Suggestions';

// Wrapper pour rediriger "/" vers Dashboard si connecté
function RootRedirect() {
  const { currentUser, loading } = useContext(AuthContext);
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="w-12 h-12 border-4 border-gray-200 border-t-black rounded-full animate-spin"></div>
      </div>
    );
  }
  
  return currentUser ? <Navigate to="/dashboard" replace /> : <Home />;
}

function App() {
  return (
    <AuthProvider>
      <ImportProvider>
      <Router>
        <ImportBanner />
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />

          {/* Routes protégées */}
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/dressing"
            element={
              <PrivateRoute>
                <Dressing />
              </PrivateRoute>
            }
          />
          <Route
            path="/add"
            element={
              <PrivateRoute>
                <AddClothing />
              </PrivateRoute>
            }
          />
          <Route
            path="/outfits"
            element={
              <PrivateRoute>
                <OutfitsToday />
              </PrivateRoute>
            }
          />
          <Route
            path="/suggestions"
            element={
              <PrivateRoute>
                <Suggestions />
              </PrivateRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <PrivateRoute>
                <Settings />
              </PrivateRoute>
            }
          />
        </Routes>
      </Router>
      </ImportProvider>
    </AuthProvider>
  );
}

export default App;
